// extracted by mini-css-extract-plugin
module.exports = {"method":"method_method__EFzn9","secondary":"method_secondary__3OKs_","primary":"method_primary__6GWBn"};